import { ReactElement } from 'react';

import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

type PatientNfzDepartmentUpdateModalCancelButtonsProps = {
   onClick: VoidFunction;
   shouldConfirmExit: boolean;
};

export const PatientNfzDepartmentUpdateModalCancelButtons = (
   props: PatientNfzDepartmentUpdateModalCancelButtonsProps
): ReactElement => {
   return (
      <>
         <ModalCancelButton onClick={props.onClick} shouldConfirmExit={props.shouldConfirmExit} />
         <ModalCloseButton onClick={props.onClick} shouldConfirmExit={props.shouldConfirmExit} />
      </>
   );
};
